<div class="spa-cancellation-status" [ngClass]="'spa-cancellation-status-' + status">
  {{ status | cancellationStatus }}
</div>
